import { configureStore } from '@reduxjs/toolkit';
import { logger } from 'redux-logger';

import processedProductsReducer,{ processedProductsProps } from './slices/productsSlice';
import ownershipReducer,{ ownersProps } from './slices/ownerShipSlice';
import authReducer from './slices/authSlice';
import groupInfoReducer,{groupInfoArrProps  } from './slices/customGroupInfoSlice';
import techRadarReducer,{techRadarArrProps  } from './slices/techRadarSlice';
import entraIdGroupReducer,{entraIdGroupProps}   from './slices/entraIdSlice';
import hierachyReducer , {hierachyProps}  from './slices/hierachySlice';
import {AuthState  } from './slices/authSlice';
import globalStateReducer, { GlobalProps } from './slices/globalVariableSlice';
import adrStateReducer,{ adrListProps } from './slices/adrSlice';

// Define the store state type
export type RootState = {
  ownersProps: ownersProps; // Ensure this matches the state structure
  dhDockComponentStatus: boolean;
  auth:AuthState,
  customGroupInfoList:groupInfoArrProps,
  techRadar:techRadarArrProps,
  processedProducts:processedProductsProps,
  entraIdGroupsProps:entraIdGroupProps,
  hierachyList:hierachyProps,
  globalState:GlobalProps,
  adrListState:adrListProps
};

// Configure the store
export const dhDockStore = configureStore({
  reducer: {
    ownersProps: ownershipReducer,
    auth: authReducer,
    groupInfo:groupInfoReducer,
    techRadar:techRadarReducer,
    processedProducts:processedProductsReducer,
    entraIdGroups:entraIdGroupReducer,
    hierachyList:hierachyReducer,
    globalState:globalStateReducer,
    adrListState:adrStateReducer
  },
  middleware: getDefaultMiddleware => {
    const middleware = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/setGlobalIdentity'],
        ignoredPaths: ['auth.identity'],
      },
    });

    if (process.env.NODE_ENV !== 'production') {
      return middleware.concat(logger);
    }
    return middleware;
  },
});

export type AppDispatch = typeof dhDockStore.dispatch;
(window as any).dhDockStore = dhDockStore;
